import { Dialog } from "@mui/material";
import React, { useState } from "react";
import { Turnstile } from "@marsidev/react-turnstile";
import CheckCircleRoundedIcon from "@mui/icons-material/CheckCircleRounded";
import ErrorOutlineRoundedIcon from "@mui/icons-material/ErrorOutlineRounded";
import { useIsDarkMode } from "../../theme/ThemeContext";

// Public page: it renders with no app chrome, so it owns its own full-page
// themed surface (.app-page) the way /status does.
const FIELD_CLASS = "app-input w-full rounded-xl border px-3 py-2.5 text-sm";

const RequestAccess = () => {
  const isDark = useIsDarkMode();
  const [loginName, setLoginName] = useState(null);
  const [accountNumber, setAccountNumber] = useState(null);
  const [customerName, setCustomerName] = useState(null);
  const [firstName, setFirstName] = useState(null);
  const [lastName, setLastName] = useState(null);
  const [contactNumber, setContactNumber] = useState(null);
  const [emailAddress, setEmailAddress] = useState(null);
  const [modal, setModal] = useState(false);
  const [content, setContent] = useState(false);
  const formRef = React.useRef();

  const handleSubmit = async (e) => {
    e.preventDefault();
    const formData = new FormData(formRef.current);
    let token = formData.get("cf-turnstile-response");

    if (
      loginName &&
      accountNumber &&
      customerName &&
      firstName &&
      lastName &&
      emailAddress
    ) {
      requestAccess(token);
    }
  };

  document.body.style = "";

  const requestAccess = async (token) => {
    var data = JSON.stringify({
      loginName: loginName,
      accountNumber: accountNumber,
      customerName: customerName,
      firstName: firstName,
      lastName: lastName,
      contactNumber: contactNumber,
      emailAddress: emailAddress,
      token: token,
    });

    const rawResponse = await fetch("/api/misc/webtrack", {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: data,
    });
    setContent(await rawResponse.json());

    setModal(true);
  };

  const field = (id, label, value, setter, type = "text", autoComplete) => (
    <div className="flex flex-col gap-1.5">
      <label htmlFor={`webtrack-${id}`} className="text-sm font-medium">
        <strong className="mr-0.5 text-rose-600 dark:text-rose-400">*</strong>
        {label}
      </label>
      <input
        id={`webtrack-${id}`}
        type={type}
        autoComplete={autoComplete}
        className={FIELD_CLASS}
        value={value}
        onChange={(e) => setter(e.target.value)}
        required
      />
    </div>
  );

  return (
    <div className="app-page flex min-h-screen flex-col items-center justify-center px-4 py-12">
      <div className="app-card w-full max-w-lg rounded-[1.75rem] border p-6 sm:p-8">
        <img
          src={
            isDark
              ? require("../../assets/NodeLogo2.png")
              : require("../../assets/NodeLogoDark.png")
          }
          alt="Big C Node"
          className="h-7 w-auto"
        />
        {!modal ? (
          <form ref={formRef} className="mt-6" onSubmit={handleSubmit}>
            <p className="app-eyebrow">Webtrack</p>
            <h1 className="mt-1 text-2xl font-bold tracking-tight">
              Request Webtrack Access
            </h1>
            <p className="app-muted mt-1 text-sm leading-relaxed">
              Fill in your account details and we'll set up your login.
            </p>

            <div className="mt-6 space-y-4">
              {field("login", "Requested Login name:", loginName, setLoginName)}
              {field(
                "account",
                "Account number or Customer code:",
                accountNumber,
                setAccountNumber
              )}
              {field(
                "company",
                "Company name:",
                customerName,
                setCustomerName,
                "text",
                "organization"
              )}
              <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
                {field(
                  "first",
                  "First name:",
                  firstName,
                  setFirstName,
                  "text",
                  "given-name"
                )}
                {field(
                  "last",
                  "Last name:",
                  lastName,
                  setLastName,
                  "text",
                  "family-name"
                )}
              </div>
              {field(
                "phone",
                "Contact number:",
                contactNumber,
                setContactNumber,
                "text",
                "tel"
              )}
              {field(
                "email",
                "Email address:",
                emailAddress,
                setEmailAddress,
                "email",
                "email"
              )}
            </div>

            <div className="mt-6 flex flex-col items-center gap-4">
              <Turnstile
                options={{
                  theme: isDark ? "dark" : "light",
                }}
                siteKey="0x4AAAAAAAOMyELVWdkY7Bls"
              />
              <button
                className="app-btn app-btn-primary app-btn-lg w-full"
                type="submit"
              >
                Request Access
              </button>
            </div>
          </form>
        ) : (
          <div className="mt-6 flex flex-col items-start gap-4">
            {content.success ? (
              <>
                <span className="app-icon-tile h-12 w-12 rounded-2xl bg-emerald-500/15 text-emerald-600 dark:text-emerald-300">
                  <CheckCircleRoundedIcon />
                </span>
                <p className="leading-relaxed">
                  All set! Your request has been sent. Account creation can
                  take 24-48 hours. If you do not receive a welcome email within
                  that time frame, please reach out to us at 574-277-4550.
                </p>
              </>
            ) : (
              <>
                <span className="app-icon-tile h-12 w-12 rounded-2xl bg-rose-500/15 text-rose-600 dark:text-rose-300">
                  <ErrorOutlineRoundedIcon />
                </span>
                <p className="leading-relaxed">
                  Error: Please call 574-277-4550 for assistance.
                </p>
              </>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default RequestAccess;
